export const words = {
    "intro1-0": {
        "EN": "Your",
        "FR": "Votre",
        "ES": "Tu",
        "POR": "Sua"
    },
    "intro1-1": {
        "EN": "experience as an",
        "FR": "expérience en tant que",
        "ES": "experiencia, como",
        "POR": "experiência como"
    },
    "intro1-2": {
        "EN": "integral part",
        "FR": "partie intégrante",
        "ES": "parte integral",
        "POR": "parte integral"
    },
    "intro1-3": {
        "EN": "of this culture",
        "FR": "de cette culture",
        "ES": "de esta cultura",
        "POR": "de esta cultura"
    },
    "intro1-4": {
        "EN": "matters",
        "FR": "compte",
        "ES": "nos importa",
        "POR": "importa"
    },
    "intro2-0": {
        "EN": "Your",
        "FR": "Vos",
        "ES": "Tu",
        "POR": "Suas"
    },
    "intro2-1": {
        "EN": "responses",
        "FR": "réponses",
        "ES": "respuestas",
        "POR": "respostas"
    },
    "intro2-2": {
        "EN": "from this survey",
        "FR": "de cette enquête",
        "ES": "en esta encuesta",
        "POR": "dessa enquete"
    },
    "intro2-3": {
        "EN": "will be used to create",
        "FR": "seront utilisées pour créer",
        "ES": "se utilizarán para crear",
        "POR": "serão usadas para criar"
    },
    "intro2-4": {
        "EN": "real change.",
        "FR": "un vrai changement.",
        "ES": "un cambio real.",
        "POR": "uma mudança real."
    },
    "intro3-0": {
        "EN": "Your",
        "FR": "Vos",
        "ES": "Tu",
        "POR": "Suas"
    },
    "intro3-1": {
        "EN": "responses",
        "FR": "réponses",
        "ES": "respuestas",
        "POR": "respostas"
    },
    "intro3-2": {
        "EN": "are anonymous",
        "FR": "sont anonymes",
        "ES": "son anónimas",
        "POR": "são anônimas"
    },
    "intro3-3": {
        "EN": " and will never be ",
        "FR": " et ne seront jamais ",
        "ES": " y nunca serán ",
        "POR": " e nunca serão "
    },
    "intro3-4": {
        "EN": "attached to",
        "FR": "attachées à",
        "ES": "vinculadas a",
        "POR": "vinculadas a"
    },
    "intro3-5": {
        "EN": "your identity.",
        "FR": "votre identité.",
        "ES": "tu identidad.",
        "POR": "sua identidade."
    },
    "intro4-0": {
        "EN": "Do you agree with your personal data being processed as described below and in our privacy statement?",
        "FR": "Êtes-vous d’accord pour que vos données personnelles soient traitées comme décrit ci-dessous dans notre déclaration de confidentialité?",
        "ES": "¿Estás de acuerdo con que tus datos personales sean procesados como se describe abajo y en nuestra declaración de privacidad?",
        "POR": "Você concorda com o processamento de seus dados pessoais conforme descrito abaixo e na nossa declaração de privacidade?"
    },
    "intro4-1": {
        "EN": "Privacy Agreement",
        "FR": "Accord de confidentialité",
        "ES": "Acuerdo de Privacidad",
        "POR": "Acordo de Privacidade"
    },
    "intro5-0": {
        "EN": "Are you over the age of 16?",
        "FR": "Avez-vous plus de 16 ans ?",
        "ES": "¿Tienes más de 16 años?",
        "POR": "Você tem mais de 16 anos?"
    },
    "intro7-0": {
        "EN":"Are you 19 years old or older?",
        "FR":"Avez-vous 19 ans ou plus?",
        "ES":"¿Tienes 19 años o más?",
        "POR": "Você tem 19 anos ou mais?"
    },
    "back": {
        "EN": "Back",
        "FR": "Retour",
        "ES": "Atrás",
        "POR": "Voltar"
    },
    "Start": {
        "EN": "Start",
        "FR": "Démarrer",
        "ES": "Empezar",
        "POR": "Iniciar"
    },
    "Next": {
        "EN": "Next",
        "FR": "Suivant",
        "ES": "Siguiente",
        "POR": "Próximo"
    },
    "I agree": {
        "EN": "I agree",
        "FR": "Je suis d'accord",
        "ES": "Estoy de acuerdo",
        "POR": "Estou de acordo"
    },
    "Submit": {
        "EN": "Submit",
        "FR": "Soumettre",
        "ES": "Enviar",
        "POR": "Enviar"
    },
    "of": {
        "EN": "of",
        "FR": "de",
        "ES": "de",
        "POR": "de"
    },
    "category": {
        "EN": "Categorical Question",
        "FR": "Question catégorique",
        "ES": "Pregunta Categórica",
        "POR": "Pergunta Categórica"
    },
    "Culture Question": {
        "EN": "Culture Question",
        "FR": "Question Culturelle",
        "ES": "Pregunta Cultural",
        "POR": "Pergunta Cultural"
    },
    "qualifier": {
        "EN": "In this culture...",
        "FR": "Dans cette culture...",
        "ES": "En esta cultura...",
        "POR": "Nesta cultura..."
    },
    "Strongly Disagree": {
        "EN": "Strongly Disagree",
        "FR": "Fortement en désaccord",
        "ES": "Muy en desacuerdo",
        "POR": "Muito em desacordo"
    },
    "Strongly Agree": {
        "EN": "Strongly Agree",
        "FR": "Fortement d'accord",
        "ES": "Totalmente de acuerdo",
        "POR": "Totalmente de acordo"
    },
    "Neutral": {
        "EN": "Neutral",
        "FR": "Neutre",
        "ES": "Neutral",
        "POR": "Neutral"
    },
    "min_feedback": {
        "EN": "We noticed you scored the following statement amongst lowest overall:",
        "FR": "Nous avons remarqué que vous avez attribué le score le plus bas pour l'énoncé suivant:",
        "ES": "Hemos notado que calificaste la siguiente afirmación entre las más bajas en general:",
        "POR": "Notamos que você classificou a seguinte afirmação entre as mais baixas no geral:"
    },
    "max_feedback": {
        "EN": "We noticed you scored the following statement amongst highest overall:",
        "FR": "Nous avons remarqué que vous avez attribué le score le plus élevé pour l'énoncé suivant:",
        "ES": "Hemos notado que calificaste la siguiente afirmación entre las más altas en general:",
        "POR": "Notamos que você classificou a seguinte afirmação entre as mais altas no geral:"
    },
    "min_feedback1": {
        "EN": "You scored a",
        "FR": "Vous avez attribué un",
        "ES": "La has calificado como",
        "POR": "Você classificou como"
    },
    "min_feedback2": {
        "EN": "Can you share context as to why you gave this score?",
        "FR": "Pouvez-vous partager un contexte sur la raison pour laquelle vous avez donné cette réponse?",
        "ES": "¿Puedes compartir contexto sobre por qué has dado esta puntuación?",
        "POR": "Você poderia nos dizer por que deu essa pontuação?"
    },
    "min_feedback3":{
        "EN":"Please provide an example of why.",
        "FR":"Veuillez fournir un exemple pour expliquer pourquoi.",
        "ES":"Por favor proporciona un ejemplo de por qué.",
        "POR": "Por favor, dê um exemplo do motivo."
    },
    "max_feedback1": {
        "EN": "We'd love to know more! Please provide an example of why you responded this way.",
        "FR": "Nous aimerions en savoir plus! Veuillez fournir un exemple pour expliquer pourquoi vous avez répondu de cette façon.",
        "ES": "¡Nos encantaría saber más! Por favor proporciona un ejemplo de por qué vous avez respondido de esta manera.",
        "POR": "Adoraríamos saber mais! Por favor, forneça um exemplo do porquê você respondeu desta forma."
    },
    "textarea": {
        "EN": "Type your answer here",
        "FR": "Tapez votre réponse ici",
        "ES": "Escribe tu respuesta aquí",
        "POR": "Escreva sua resposta aqui"
    },
    "Skip": {
        "EN": "Skip",
        "FR": "Sauter",
        "ES": "Omitir",
        "POR": "Omitir"
    },
    "do_not_wish_to_answer": {
        "EN": "Skip if you prefer not to say",
        "FR": "Sauter si vous préférez ne pas répondre",
        "ES": "Omitir si prefieres no decir",
        "POR": "Omitir se você preferir não dizer"
    },
    'welcomeMessage': {
        'EN': 'We understand that your time is precious, but we\'d like to take a moment to emphasize how important your feedback is to us. Your thoughts and insights can make a world of difference!',
        'FR': 'Nous comprenons que votre temps est précieux, mais nous aimerions prendre un moment pour souligner à quel point vos retours sont importants pour nous. Vos pensées et insights peuvent faire toute la différence !',
        'ES': 'Entendemos que tu tiempo es precioso, pero nos gustaría tomar un momento para enfatizar cuán importante es tu feedback para nosotros. ¡Tus pensamientos y percepciones pueden marcar una gran diferencia!',
        'POR': 'Entendemos que seu tempo é precioso, mas gostaríamos de tomar um momento para enfatizar quão importante é o seu feedback para nós. Seus pensamentos e insights podem fazer toda a diferença!'
    },
    'driveChangeTitle': {
        'EN': 'Drive meaningful change',
        'FR': 'Provoquer un changement significatif',
        'ES': 'Impulsar un cambio significativo',
        'POR': 'Impulsionar uma mudança significativa'
    },
    'driveChangeText': {
        'EN': 'Your feedback pinpoints areas for improvement, enabling us to prioritize and implement impactful changes.',
        'FR': 'Vos retours identifient les domaines à améliorer, nous permettant de prioriser et mettre en œuvre des changements significatifs.',
        'ES': 'Tu feedback identifica áreas para mejorar, permitiéndonos priorizar e implementar cambios significativos.',
        'POR': 'Seu feedback identifica áreas para melhorar, permitindo-nos priorizar e implementar mudanças significativas.'
    },
    'reinforceStrengthsTitle': {
        'EN': 'Reinforce our strengths',
        'FR': 'Renforcer nos points forts',
        'ES': 'Reforzar nuestras fortalezas',
        'POR': 'Reforçar nossos pontos fortes'
    },
    'reinforceStrengthsText': {
        'EN': 'Your positive feedback helps us maintain and enhance the features that resonate with you, ensuring exceptional services.',
        'FR': 'Vos retours positifs nous aident à maintenir et améliorer les fonctionnalités qui vous parlent, assurant des services exceptionnels.',
        'ES': 'Tu feedback positivo nos ayuda a mantener y mejorar las características que resuenan contigo, asegurando servicios excepcionales.',
        'POR': 'Seu feedback positivo nos ajuda a manter e melhorar as funcionalidades que ressoam com você, garantindo serviços excepcionais.'
    },
    'influenceDecisionsTitle': {
        'EN': 'Influence strategic decisions',
        'FR': 'Influencer les décisions stratégiques',
        'ES': 'Influir en las decisiones estratégicas',
        'POR': 'Influenciar decisões estratégicas'
    },
    'influenceDecisionsText': {
        'EN': 'Your input informs our decision-making process, leading to a more responsive and user-focused organization.',
        'FR': 'Vos contributions éclairent notre processus décisionnel, menant à une organisation plus réactive et centrée sur l\'utilisateur.',
        'ES': 'Tu aporte informa nuestro proceso de toma de decisiones, llevando a una organización más receptiva y centrada en el usuario.',
        'POR': 'Sua contribuição informa nosso processo de tomada de decisão, levando a uma organização mais responsiva e focada no usuário.'
    },
    "Leave feedback": {
        "EN": "Leave feedback",
        "FR": "Laisser un commentaire",
        "ES": "Dejar feedback",
        "POR": "Deixar feedback"
    },
    "Skip anyway": {
        "EN": "Skip anyway",
        "FR": "Passer quand même",
        "ES": "Omitir de todos modos",
        "POR": "Omitir de todos modos"
    },
    "sharing": {
        "EN": "By sharing your experiences, you help us:",
        "FR": "En partageant vos expériences, vous nous aidez à :",
        "ES": "Al compartir tus experiencias, nos ayudas a:",
        "POR": "Ao compartilhar suas experiências, você nos ajuda a:"
    },
    "matters": {
        "EN": "Your Feedback Matters!",
        "FR": "Vos retours sont importants !",
        "ES": "¡Tu Feedback Importa!",
        "POR": "Seu feedback é importante!"
    },
    "Very Poor": {
        "EN": "Very Poor",
        "FR": "Très mauvais",
        "ES": "Muy Malo",
        "POR": "Muito Ruim"
    },
    "Excellent": {
        "EN": "Excellent",
        "FR": "Excellent",
        "ES": "Excelente",
        "POR": "Excelente"
    },
    "Congratulations": {
        "EN": "Click Submit below to complete the survey!",
        "FR": "Cliquez sur Soumettre ci-dessous pour terminer le sondage !",
        "ES": "¡Haz clic en Enviar para completar la encuesta!",
        "POR": "Clique em Enviar para completar a pesquisa!"
    },
    "Value": {
        "EN": "Your valuable insights matter to us. Go ahead and hit that",
        "FR": "Vos précieux retours nous importent. Allez-y et appuyez sur",
        "ES": "Tu percepcion es valiosa e importante para nosotros. Presiona el botón",
        "POR": "Sua percepção é valiosa e importante para nós. Pressione o botão"
    },
    "Value2": {
        "EN": "button to share your thoughts and help shape our organization’s future.",
        "FR": "pour partager vos pensées et aider à façonner l'avenir de notre organisation.",
        "ES": "para compartir tus pensamientos y ayudar a construir el futuro de nuestra organización.",
        "POR": "para compartilhar seus pensamentos e ajudar a construir o futuro da nossa organização."
    },
    "Feedback": {
        "EN": "Feedback",
        "FR": "Commentaire",
        "ES": "Feedback",
        "POR": "Feedback"
    },
    "category_completed":{
        "EN":"Thank you for answering these preliminary questions.",
        "FR":"Merci d'avoir répondu à ces questions préliminaires.",
        "ES":"Gracias por responder a estas preguntas preliminares.",
        "POR": "Obrigado por responder a estas perguntas preliminares."
    },
    "category_completed2":{
        "EN":"Now we are going to ask you some questions about your experience with {organizationName}. Your perspectives are important.",
        "FR":"Maintenant, nous allons vous poser quelques questions sur votre expérience avec {organizationName}. Vos perspectives sont importantes.",
        "ES":"Ahora vamos a hacerte algunas preguntas sobre tu experiencia con {organizationName}. Tus perspectivas son importantes.",
        "POR": "Agora vamos fazer algumas perguntas sobre sua experiência com {organizationName}. Suas perspectivas são importantes."
    },
    "Searching":{
        "EN":"Looking for an existing response",
        "FR":"Recherche d'une réponse existante",
        "ES":"Buscando una respuesta existente",
        "POR": "Procurando uma resposta existente"
    },
    "Searching2":{
        "EN":"It looks like we've found an existing survey response. Would you like to:",
        "FR":"Il semble que nous ayons trouvé une réponse à l'enquête existante. Souhaitez-vous :",
        "ES":"Parece que hemos encontrado una respuesta existente a la encuesta. ¿Te gustaría:",
        "POR": "Parece que encontramos uma resposta existente para a pesquisa. Você gostaria de:"
    },
    'Restart':{
        "EN":'Restart the survey',
        "FR":'Redémarrer l\'enquête',
        "ES":'Reiniciar la encuesta',
        "POR": 'Reiniciar a pesquisa'
    },
    "Load":{
        "EN":"Load the existing response",
        "FR":"Charger la réponse existante",
        "ES":"Cargar la respuesta existente",
        "POR": "Carregar a resposta existente"
    },
    "completed_on":{
        "EN":"This survey was completed on",
        "FR":"Ce sondage a été complété le",
        "ES":"Esta encuesta fue completada el",
        "POR": "Esta pesquisa foi completada em"
    },
    "survey_status1":{
        "EN":"We're sorry but this survey has been closed and is no longer available.",
        "FR":"Nous sommes désolés, mais ce sondage a été fermé et n'est plus disponible.",
        "ES":"No podemos obtener información sobre esta encuesta.",
        "POR": "Não podemos obter informações sobre esta pesquisa."
    },
    "team_qualifier":{
        "EN":"In {team}'s culture...",
        "FR":"Dans la culture de {team}...",
        "ES":"En la cultura de {team}...",
        "POR": "Na cultura de {team}..."
    },
    "In the hockey environment (training and competition)...":{
        "EN":"In the hockey environment (training and competition)...",
        "FR":"Dans l'environnement du hockey (entraînement et compétition)...",
        "ES":"En el entorno del hockey (entrenamiento y competencia)...",
        "POR": "No ambiente do hockey (treinamento e competição)..."
    },
    "intro4-2":{
        "EN":"DISCLAIMER: This survey uses conversational AI at times to ask more specifically about your experiences. If you are uncomfortable with any AI prompt and do not want to respond, please just hit the skip button. Thank you.",
        "FR":"AVERTISSEMENT : Cette enquête utilise l'IA conversationnelle parfois pour demander plus spécifiquement sur vos expériences. Si vous n'êtes pas à l'aise avec une invite d'IA et ne souhaitez pas répondre, appuyez simplement sur le bouton Ignorer. Merci.",
        "POR": "AVISO: Esta pesquisa utiliza IA conversacional em alguns momentos para perguntar mais especificamente sobre suas experiências. Se você não se sentir confortável com alguma pergunta da IA e não quiser responder, basta clicar no botão 'Pular'. Obrigado."
    },
    "Slightly Disagree":{
        "EN":"Slightly Disagree",
        "FR":"Légèrement en désaccord",
        "ES":"Ligeramente en desacuerdo",
        "POR": "Ligeiramente em desacordo"
    },
    "Slightly Agree":{
        "EN":"Slightly Agree",
        "FR":"Légèrement d'accord",
        "ES":"Ligeramente de acuerdo",
        "POR": "Ligeiramente de acordo"
    },
    "Agree":{
        "EN":"Agree",
        "FR":"D'accord",
        "ES":"De acuerdo",
        "POR": "De acordo"
    },
    "Disagree":{
        "EN":"Disagree",
        "FR":"En désaccord",
        "ES":"En desacuerdo",
        "POR": "Em desacordo"
    },
    "Follow Up":{
        "EN":"Follow Up",
        "FR":"Suivi",
        "ES":"Seguimiento",
        "POR": "Acompanhamento"
    },
    "Remmber_Submission":{
        "EN":"Reminder: once you submit, you won't be able to reopen the survey or change your answers.",
        "FR":"Rappel : une fois que vous avez soumis, vous ne pourrez plus ouvrir le sondage ou modifier vos réponses.",
        "ES":"Recordatorio: una vez que envíes, no podrás volver a abrir la encuesta o cambiar tus respuestas.",
        "POR": "Lembrete: uma vez que você enviar, você não poderá reabrir a pesquisa ou alterar suas respostas."
    },
    "Completed":{
        "EN":"Thank you for completing the survey!",
        "FR":"Merci d'avoir répondu à l'enquête.",
        "ES":"Gracias por completar la encuesta.",
        "POR": "Obrigado por completar a pesquisa."
    },
    "ai_reminder_title": {
        "EN": "Responsible use of AI reminder:",
        "FR": "Rappel sur l'utilisation responsable de l'IA :",
        "ES": "Recordatorio sobre el uso responsable de la IA:",
        "POR": "Lembrete de uso responsável de IA:"
    },
    "ai_reminder_body": {
        "EN": "Your responses here are completely private and secure. The conversational AI only builds on what you’ve already shared, and never receives personal identifiers. Engaging with it helps provide richer context to your feedback, but you can always skip if you prefer.",
        "FR": "Vos réponses ici sont entièrement privées et sécurisées. L’IA conversationnelle ne s’appuie que sur ce que vous avez déjà partagé et ne reçoit jamais d’identifiants personnels. Interagir avec elle aide à donner plus de contexte à vos réponses, mais vous pouvez toujours passer si vous préférez.",
        "ES": "Tus respuestas aquí son completamente privadas y seguras. La IA conversacional solo se basa en lo que ya has compartido y nunca recibe identificadores personales. Interactuar con ella ayuda a aportar un contexto más rico a tus comentarios, pero siempre puedes omitir si lo prefieres.",
        "POR": "As suas respostas aqui são totalmente privadas e seguras. A IA conversacional baseia-se apenas no que você já compartilhou e nunca recebe identificadores pessoais. Interagir com ela ajuda a fornecer um contexto mais rico ao seu feedback, mas você sempre pode pular se preferir."
    },
    "Not at all likely":{
        "EN":"Not at all likely",
        "FR":"Pas du tout probable",
        "ES":"Nada probable",
        "POR": "Nada provável"
    },
    "Extremely likely":{
        "EN":"Extremely likely",
        "FR":"Extrêmement probable",
        "ES":"Extremadamente probable",
        "POR": "Extremamente provável"
    }
    ,
    "Clear": {
        "EN": "Clear",
        "FR": "Effacer",
        "ES": "Limpiar",
        "POR": "Limpar"
    }
}